// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import CockpitNotificationStateViewModel from '../../../../viewModel/resource/CockpitNotificationStateViewModel';
import CockpitNotificationViewModel from '../../../../viewModel/resource/CockpitNotificationViewModel';
import CockpitNotificationDTO from '../../dto/resource/CockpitNotificationDTO';

export default abstract class CockpitNotificationModel extends BaseModel<CockpitNotificationDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get recipient() { return this.dto.recipient; }
  set recipient(value) { this.dto.recipient = value; }
  /**
  * @type {int64}
  */
  get recipientId() { return this.dto.recipientId; }
  set recipientId(value) { this.dto.recipientId = value; }
  /**
  */
  get mailTemplateId() { return this.dto.mailTemplateId; }
  set mailTemplateId(value) { this.dto.mailTemplateId = value; }
  /**
  */
  get subject() { return this.dto.subject; }
  set subject(value) { this.dto.subject = value; }
  /**
  * @type {int32}
  */
  get state() { return this.dto.state; }
  set state(value) { this.dto.state = value; }
  /**
  */
  get information() { return this.dto.information; }
  set information(value) { this.dto.information = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modified = qs.modified;
    this.dto.recipient = qs.recipient;
    value = Number.parseFloat(qs.recipientid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.recipientId = value;
    this.dto.mailTemplateId = qs.mailtemplateid;
    this.dto.subject = qs.subject;
    value = Number.parseFloat(qs.state);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.state = value;
    this.dto.information = qs.information;
  }
}
